import classnames from 'classnames';
import React from 'react';

const CampaignContentGuidelineItem = ({description, must = false}) => {
    return (
        <div className="campaign-guideline-item">
            <span
                className={classnames(
                    'guideline-icon', must ? 'must-guideline-icon' : 'must-not-guideline-icon'
                )}
                color={must ? 'var(--green-01)' : 'var(--pink-01)'}
            />

            <span className="campaign-guideline-item-description">
                {description}
            </span>
        </div>
    )
}

export default CampaignContentGuidelineItem;



// WEBPACK FOOTER //
// ./components/campaign_content_guidelines/campaign_content_guideline_item.js